import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Endpoints } from 'src/app/shared/config/endpoints';
import { GeneralService } from '../general.service';
import { BehaviorSubject } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';

@Injectable({
  providedIn: 'root'
})
export class FitnessService {
  private orgId: number;
  private base_uri: string;

  fitness: any = new BehaviorSubject<any>({});

  constructor(
    private http: HttpClient,
    private endpoints: Endpoints,
    private general_service: GeneralService,
    private store: Store<AppState>,
  ) {
    this.store.select('userInfo').subscribe( info => {
      if (Object.keys(info).length) {
        this.orgId = info.organization.id;
      }
    })
    this.base_uri = `${this.endpoints.fourFourSixEndpoint}/organisations-fitness`;
  }

  create_record() {
    return this.http.post(this.base_uri, {});
  }

  fetch_org_fitness_record() {
    return this.http.get(this.base_uri);
  }

  update_org_fitness_record(data: any) {
    return this.http.put(this.base_uri, { ...data });
  }
}
